import React, { useState, useEffect } from "react";

import ArticleList from "../article-list/ArticleList";
import useRelatedArticles from "../../hooks/useRelatedArticles";

function PostRelated() {
  const [articlesToShowCount, setArticlesToShowCount] = useState(4);
  const relatedArticles = useRelatedArticles(articlesToShowCount);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  })

  function handleResize() {
    const newArticlesToShowCount = window.innerWidth > 992 ? 4 : 3;
    setArticlesToShowCount(newArticlesToShowCount);
  }

  return <ArticleList articles={relatedArticles} />;
}

export default PostRelated;
